export default __webpack_public_path__ + "static/media/test.3b9f518c.webp";